import { HttpClient } from '@angular/common/http';
import { Injectable, Signal, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { URLS } from '../config/urls';
import { Conversation, ModelResponse } from '../types/types';
import { WorkflowState } from '../state/state.state';
import {
  saveAppProfile,
  saveResultToWorklow,
  setErrorState,
  updateAppProfileByKey,
} from '../state/state.actions';
import { AlertService } from 'projects/shared-new/src/lib/services-new/alert.service';
import { StateService } from '../state.service';

@Injectable({
  providedIn: 'root',
})
export class ConversationService {
  constructor(private store: Store<{ workflow: WorkflowState }>) {}

  private httpClient = inject(HttpClient);
  private alertService = inject(AlertService);
  private stateService = inject(StateService);

  stateSignal$: Signal<{
    workflow: WorkflowState;
  }> = this.stateService.getAppState();

  askGenAi(
    conversation: Conversation[],
    responseKey: string | string[],
    processKey: string,
  ): void {
    this.httpClient
      .post<ModelResponse[]>(URLS.CONVERSATION, conversation)
      .subscribe({
        next: (modelResponse) => {
          switch (processKey) {
            case 'postProcess': {
              this.setPostProcess(modelResponse, responseKey);
              break;
            }
            case 'profile': {
              if (typeof responseKey == 'string') {
                this.setProfile(modelResponse, responseKey);
              }
              break;
            }
            default: {
              break;
            }
          }
        },
        error: (error) => {
          this.store.dispatch(setErrorState({ error: true }));
          this.alertService.error(
            'Oops! It seems like there was an issue generating your post. Please try again.',
          );
        },
      });
  }

  setPostProcess(
    modelResponse: ModelResponse[],
    responseKey: string | string[],
  ): void {
    const response = modelResponse[0].responses;
    let modelResponseInput = {};
    if (typeof responseKey == 'string') {
      this.store.dispatch(
        saveResultToWorklow({ modelResponse: { [responseKey]: response } }),
      );
      modelResponseInput = { [responseKey]: response };
    } else {
      for (let i = 0; i < responseKey.length; i++) {
        this.store.dispatch(
          saveResultToWorklow({
            modelResponse: { [responseKey[i]]: response },
          }),
        );
      }
    }
  }

  setProfile(modelResponse: ModelResponse[], responseKey: string): void {
    this.store.dispatch(
      updateAppProfileByKey({
        key: responseKey,
        value: modelResponse[0].responses,
      }),
    );
    this.store.dispatch(
      saveAppProfile({
        appProfile: this.stateSignal$().workflow.profile.appProfile,
      }),
    );
  }
}
